export class DcFileDTO {
    public base64: string;
    public contentBytes: string;
    public contentType: string;
    public fileId: number;
    public name: string;

    public static build(): DcFileDTO {
        const dcFileDto: DcFileDTO = new DcFileDTO();
        dcFileDto.base64 = null;
        dcFileDto.contentBytes = null;
        dcFileDto.contentType = null;
        dcFileDto.fileId = null;
        dcFileDto.name = null;
        return dcFileDto;
    }
}